import styled from 'styled-components';
import { LandingPageTemplate } from '../LandingPageTemplate';

export const StyledEnterpriseLandingPage = styled(LandingPageTemplate)`
  color: ${(props) => props.theme.textColor};
`;
